<template>
  <v-container fluid class="pa-0">
    <IntroText
      :intro-one="pageItem.MainText"
      :pageItem="pageItem"
    />
    <v-container>
      <v-row v-if="vacancies && vacancyItem.length !== 0">
        <v-col
          v-for="item in vacancyItem"
          :key="item.Code"
          cols="12"
          sm="6"
        >
          <v-row v-if="item.Code && item.NameUrl">
            <v-col cols="4" sm="4" md="4" lg="3" xl="2">
             <NVEAROverviewImg :item="item"/>
            </v-col>
            <v-col cols="8" sm="8" md="8" lg="9" xl="10" class="pt-0">
              <NuxtLink
                :to="{ path: $methods.pageUrlByPageType('DV') + '/' + item.NameUrl }"
                class="text-decoration-none text-primary"
              >
                <h2>
                  {{ item.Title }}
                </h2>
              </NuxtLink>
              {{ item.WorkPlace }}
              <p></p>
              <p class="text--text" v-if="item.MainText">
                <span v-html="$helpers.stripHtml(item.MainText, 175)" />...
                <NuxtLink
                  :to="{ path: $methods.pageUrlByPageType('DV') + '/' + item.NameUrl }"
                  class="text-decoration-none info--text"
                >
                  {{ dataAll.getStatic('read_more', 'Read more') }}
                </NuxtLink>
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <PaginationUrl :total="vacancies?.length || 0" :per-page="perPage" />
    </v-container>
  </v-container>
</template>

<script setup>
import IntroText from "@/components/Base/introText.vue";
import PaginationUrl from "@/components/Base/PaginationUrl.vue";
import NVEAROverviewImg from "@/components/Base/NVEAROverviewImg.vue";

const dataAll = useDataAll();
const { $apiMethods, $methods, $helpers } = useNuxtApp();
const perPage = 4;

const props = defineProps({
  pageItem: {
    type: Object,
    default: "",
  },
});

const vacancies = await $apiMethods.loadJSONApi(
  $apiMethods.getOverviewNewsEventvacancyItem("vacanciesOverview")
).catch(err => {
  console.log(err);
  throw createError({ statusCode: 503, statusMessage: "vacancies can not be loaded" });
});
console.error(vacancies)
const { currentPage } = await usePageQuery(vacancies?.length, perPage);

const vacancyItem = computed(() => {
  return [...(vacancies || [])]
    .reverse()
    .slice((currentPage.value - 1) * perPage, currentPage.value * perPage);
});
</script>